import { Fragment } from 'react'

import { Heading } from '@ui/typography/Heading'

import {
  SubTitle,
  Cards,
  Wrapper,
  Card,
  TableTitle,
  TableSubtitle,
  List,
  ListItem,
} from './styles'
import { ResultSectionProps } from './types'

export function ResultSection({
  title,
  text,
  cards,
  mobilePadding,
}: ResultSectionProps) {
  return (
    <Wrapper mobilePadding={mobilePadding}>
      <Heading title={title} />
      {text.map(({ id, text, benefits }) => (
        <Fragment key={id}>
          <SubTitle>{text}</SubTitle>
          {benefits && (
            <List>
              {benefits.map(({ id, title }) => (
                <ListItem key={id}>{title}</ListItem>
              ))}
            </List>
          )}
        </Fragment>
      ))}
      {cards?.length && (
        <Cards>
          {cards?.map(({ title, subtitle }) => (
            <Card key={subtitle}>
              <TableTitle as="h3">{title}</TableTitle>
              <TableSubtitle>{subtitle}</TableSubtitle>
            </Card>
          ))}
        </Cards>
      )}
    </Wrapper>
  )
}
